import type { ReactElement } from "react";

import {
    StyledOnboardingHubProgress,
    StyledOnboardingHubProgressLine,
} from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubProgress/styles";

const HUNDRED_PERCENT = 100;

export interface OnboardingHubProgressBaseProps {
    completedItemsCount: number;
    totalItemsCount: number;
}

interface OnboardingHubProgressProps extends OnboardingHubProgressBaseProps {
    isBold: boolean;
}

const OnboardingHubProgress = ({
    completedItemsCount,
    totalItemsCount,
    isBold,
}: OnboardingHubProgressProps): ReactElement => {
    return (
        <StyledOnboardingHubProgress isBold={isBold}>
            <StyledOnboardingHubProgressLine
                isBold={isBold}
                progress={totalItemsCount ? Math.ceil((completedItemsCount * HUNDRED_PERCENT) / totalItemsCount) : 0}
            />
        </StyledOnboardingHubProgress>
    );
};

export default OnboardingHubProgress;
